module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_ranking2.db46d.png";